import { useObservable } from "@vueuse/rxjs";
import { Observable } from "rxjs";

export const bind = <T>(o: Observable<T>) => useObservable(o) as unknown as T;
